import { render, staticRenderFns } from "./activity-guidance-scoring-attendants.vue?vue&type=template&id=12a4988a"
import script from "./activity-guidance-scoring-attendants.vue?vue&type=script&lang=js"
export * from "./activity-guidance-scoring-attendants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports